<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm07_contents"><a id="page_ix"></a><strong>CONTENTS</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/ch01#ch01">One The Emperor</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">Two The Queen of Spades</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">Three The Zero Winter</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Four The Rock</span><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm07_contents.vue?6a303772